import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {createColourPalette} from 'apiCalls/apiCalls';
import {ErrorMessage, Loading} from 'components/CommonComponents';
import {useColourPaletteStateRefactor} from "hooks/useColourPaletteStateRefactor";
import {ColourPaletteForm} from "components/ColourPalette/ColourPaletteForm";

export const CreateColourPaletteComponent = () => {
    const [apiRequestStatus, colours, setColours, selectedColours, setSelectedColours, name, setName] = useColourPaletteStateRefactor();
    const [pending, setPending] = useState(false);
    const [error, setError] = useState(null);
    let navigate = useNavigate();

    const submitColourPalette = async (name, colours) => {
        setPending(true);

        if(colours.length === 0) {
            setError({message: 'Colour Palette must have at least one Colour'});
            setPending(false);
        } else {
            try {
                const newColourPalette = await createColourPalette(name, colours);
                setError(null);
                setPending(false);
                navigate(`/colour-palettes/${newColourPalette.id}`);
            } catch (e) {
                setError(e.message);
                setPending(false);
            }
        }
    };

    return (
        <>
            {(apiRequestStatus?.loading || pending) && <Loading/>}
            {(apiRequestStatus?.error || error) && <ErrorMessage message={error.message}/>}
            {!pending && !error && (!(apiRequestStatus?.loading) && !(apiRequestStatus?.error)) && (
                <ColourPaletteForm
                    colours={colours}
                    setColours={setColours}
                    selectedColours={selectedColours}
                    setSelectedColours={setSelectedColours}
                    name={name}
                    setName={setName}
                    buttonText={'Create a Colour Palette'}
                    submitColourPalette={() => submitColourPalette(name, selectedColours)}
                />
            )}
        </>
    );
};
